import { render, staticRenderFns } from "./LeaveButton.vue?vue&type=template&id=50b01836"
import script from "./LeaveButton.vue?vue&type=script&lang=js"
export * from "./LeaveButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports